import { auth, db } from './firebase';
import { updatePassword, EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { doc, updateDoc, serverTimestamp, getDoc } from 'firebase/firestore';

/**
 * Verifica se o usuário precisa trocar a senha
 */
export const checkMustChangePassword = async (userId) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    
    if (userSnap.exists()) {
      return userSnap.data().mustChangePassword === true;
    }
    
    return false;
  } catch (error) {
    console.error('Erro ao verificar senha:', error);
    return false;
  }
};

/**
 * Altera a senha do usuário e remove a flag de troca obrigatória
 */
export const changePassword = async (currentPassword, newPassword) => {
  try {
    const user = auth.currentUser;
    
    if (!user || !user.email) {
      throw new Error('Usuário não autenticado');
    }

    // Verificar se usuário usa Google Auth
    const isGoogleUser = user.providerData.some(p => p.providerId === 'google.com');
    
    if (isGoogleUser) {
      // Usuário do Google não precisa reautenticar com senha
      // Apenas atualiza a senha (opcional para Google users)
      await updatePassword(user, newPassword);
    } else {
      // Reautenticar usuário com senha atual
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      await reauthenticateWithCredential(user, credential);
      
      // Atualizar senha
      await updatePassword(user, newPassword);
    }

    // Remover flag de troca obrigatória no Firestore
    const userRef = doc(db, 'users', user.uid);
    await updateDoc(userRef, {
      mustChangePassword: false,
      passwordChangedAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });

    return { success: true };
  } catch (error) {
    console.error('Erro ao alterar senha:', error);
    
    let message = 'Erro ao alterar senha';
    
    // Tratamento detalhado de erros
    if (error.code === 'auth/wrong-password' || error.code === 'auth/invalid-credential') {
      message = 'Senha atual incorreta. Verifique e tente novamente.';
    } else if (error.code === 'auth/weak-password') {
      message = 'Nova senha muito fraca. Use pelo menos 6 caracteres';
    } else if (error.code === 'auth/requires-recent-login') {
      message = 'Por segurança, faça login novamente';
    } else if (error.code === 'auth/user-mismatch') {
      message = 'Credenciais não correspondem ao usuário atual';
    } else if (error.code === 'auth/invalid-email') {
      message = 'Email inválido';
    }
    
    return { success: false, error: message };
  }
};

/**
 * Valida força da senha
 */
export const validatePasswordStrength = (password) => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  const validations = {
    length: password.length >= minLength,
    upperCase: hasUpperCase,
    lowerCase: hasLowerCase,
    numbers: hasNumbers,
    specialChar: hasSpecialChar
  };

  const score = Object.values(validations).filter(Boolean).length;
  
  let strength = 'weak';
  if (score >= 5) strength = 'strong';
  else if (score >= 3) strength = 'medium';

  return {
    isValid: password.length >= 6, // Firebase mínimo
    isStrong: score >= 4,
    strength,
    validations
  };
};
